/**
 * Territory Filters - Dynamic Municipality Selection
 * Filters municipalities based on selected department
 */

class TerritoryFilters {
  constructor() {
    this.departmentSelect = document.getElementById("departament");
    this.citySelect = document.getElementById("city");
    this.filtersResponse = document.getElementById("filters-response");
    this.territoryData = window.territoryData || [];

    this.init();
  }

  init() {
    if (!this.departmentSelect || !this.citySelect) {
      console.warn("Territory filter elements not found");
      return;
    }

    this.bindEvents();
    this.initializeDefaultSelection();
  }

  bindEvents() {
    this.departmentSelect.addEventListener("change", (e) => {
      this.handleDepartmentChange(e.target.value);
    });

    this.citySelect.addEventListener("change", (e) => {
      this.handleCityChange(e.target.value);
    });
  }

  handleDepartmentChange(departmentId) {
    // Clear current city options except the default
    this.clearCityOptions();

    if (!departmentId) {
      return;
    }

    // Find the selected department
    const selectedDepartment = this.territoryData.find(
      (dept) => dept.departamento_id === departmentId
    );

    if (selectedDepartment && selectedDepartment.municipios) {
      this.populateCities(selectedDepartment.municipios);
      // Update programs for the first municipality of the selected department
      if (selectedDepartment.municipios.length > 0) {
        this.updatePrograms(
          departmentId,
          selectedDepartment.municipios[0].municipio_id
        );
      }
    }
  }

  clearCityOptions() {
    // Keep only the default option
    this.citySelect.innerHTML =
      '<option value="" disabled selected>Municipios</option>';
  }

  populateCities(municipalities) {
    municipalities.forEach((municipality, index) => {
      const option = document.createElement("option");
      option.value = municipality.municipio_id;
      option.textContent = municipality.municipio;

      // Select the first municipality by default
      if (index === 0) {
        option.selected = true;
      }

      this.citySelect.appendChild(option);
    });
  }

  initializeDefaultSelection() {
    // Load municipalities for the default selected department
    const selectedDepartmentId = this.departmentSelect.value;
    if (selectedDepartmentId) {
      this.handleDepartmentChange(selectedDepartmentId);
    }
  }

  handleCityChange(municipalityId) {
    const departmentId = this.departmentSelect.value;
    if (departmentId && municipalityId) {
      this.updatePrograms(departmentId, municipalityId);
    }
  }

  updatePrograms(departmentId, municipalityId) {
    this.showLoading();

    // Get department and municipality text values
    const departmentText =
      this.departmentSelect.options[this.departmentSelect.selectedIndex].text;
    const municipalityText =
      this.citySelect.options[this.citySelect.selectedIndex].text;

    // Make AJAX request to get programs using PHP templates
    fetch(tdea_ajax.ajax_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        action: "territory_filter_programs",
        nonce: tdea_ajax.nonce,
        department_id: departmentId,
        municipality_id: municipalityId,
        department: departmentText,
        municipality: municipalityText,
        map_programs: false,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          this.renderProgramsFromAjax(data.data.html);
        } else {
          this.showNoPrograms();
          console.error("Error loading programs:", data.data);
        }
      })
      .catch((error) => {
        console.error("AJAX Error:", error);
        this.showNoPrograms();
      });
  }

  showLoading() {
    const loadingState = this.filtersResponse.querySelector(".loading-state");
    const programsContainer = this.filtersResponse.querySelector(
      ".programs-container"
    );

    if (loadingState) loadingState.style.display = "grid";
    if (programsContainer) programsContainer.style.display = "none";
  }

  hideLoading() {
    const loadingState = this.filtersResponse.querySelector(".loading-state");
    const programsContainer = this.filtersResponse.querySelector(
      ".programs-container"
    );

    if (loadingState) loadingState.style.display = "none";
    if (programsContainer) programsContainer.style.display = "grid";
  }

  renderProgramsFromAjax(html) {
    const programsContainer = this.filtersResponse.querySelector(
      ".programs-container"
    );
    if (!programsContainer) return;

    // Clear current programs and insert new HTML from PHP template
    programsContainer.innerHTML = html;

    this.hideLoading();
  }

  showNoPrograms() {
    const programsContainer = this.filtersResponse.querySelector(
      ".programs-container"
    );
    if (programsContainer) {
      programsContainer.innerHTML =
        "<p>No hay programas disponibles para esta selección.</p>";
    }
    this.hideLoading();
  }
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  new TerritoryFilters();
});

// Export for potential use in other modules
if (typeof module !== "undefined" && module.exports) {
  module.exports = TerritoryFilters;
}
